import React from 'react'
import { ReactComponent as GoldenArrow } from '../../../assets/endorseBanner/goldenArrow.svg'
import { Button } from '../Button'
import EndorsementButton from '../../public/Company/Profile/components/Endorsement/EndorsementButton';
import GenericTooltipComponent from '../../public/Company/Profile/components/assets/GenericTooltipComponent';

function EndorsementBanner({ company, role, purchaseSubScriptionValid, companyType, userInfo, trevexId, handleVerifyProfile }) {
    return (
        ((companyType === 'claimed' && (company?.endorsements > 0 || company?.endorsements?.available) && role) || !role || company?.endorsements?.message === null) && <div>{(
            <div className="bg-[#002940] w-full text-slate font-semibold p-2 rounded-b-lg">
                <div className='flex justify-between items-center m-auto md:px-[1rem] lg:px-[1.75rem]'>
                    {<div className='flex w-auto sm:w-[50%] gap-3'>
                        {(!purchaseSubScriptionValid && !role) || (role && companyType === "claimed") || company?.endorsements?.available ? <div>
                            <Button classes={'bg-transparent flex gap-2 text-[#FFC36B] text-f12 text-left sm:text-f14 sm:text-center font-semibold cursor-text'}>
                                {(company?.endorsements?.available || (typeof (company?.endorsements) === 'number' && company?.endorsements > 0) || company?.endorsements?.message === null) && <p>{role && companyType === "claimed" ? `Get your company verified to view payment timeliness endorsement(s)` : company?.endorsements?.available ? "Purchase this company profile to view endorsement(s)" : null}</p>}
                                {(company?.endorsements?.available || (typeof (company?.endorsements) === 'number' && company?.endorsements > 0) || (role && company?.endorsements?.message === null))}
                            </Button>
                        </div> : null}
                    </div>}
                    {(companyType === "claimed" || companyType == "verified") && !role && (
                        <EndorsementButton userInfo={userInfo} company={company} trevexId={trevexId} />
                    )}
                </div>
            </div>
        )}</div>
    )
}

export default EndorsementBanner